@if (!isLoggedIn) {
  <div class="login-form"
       [formGroup]="form">
    <input type="hidden"
           name="ReturnUrl"
           id="ReturnUrl"
           formControlName="returnUrl">
    <input type="hidden"
           name="OverrideSessions"
           id="OverrideSessions"
           formControlName="overrideSessions">

    <mat-form-field id="username"
                    appearance="outline">
      <mat-label>Username</mat-label>

      <input matInput
             type="text"
             id="txtUserName"
             autocomplete="username"
             formControlName="username"
             name="Username"
             autofocus
             required>
      <mat-error>
        @if (form.controls.username.hasError('required')) {
          Username is required
        }
      </mat-error>
    </mat-form-field>

    <mat-form-field id="password"
                    appearance="outline">
      <mat-label>Password</mat-label>

      <input matInput
             type="password"
             id="txtPassword"
             autocomplete="current-password"
             formControlName="password"
             name="Password"
             required>
      <mat-error>
        @if (form.controls.password.hasError('required')) {
          Password is required
        }
      </mat-error>
    </mat-form-field>

    @if (badLogInAttempt) {
      <ez-login-errors [badLogInAttempt]="badLogInAttempt"
                       [forgotPasswordUrl]="forgotPasswordUrl"
                       [isAutomationUser]="isAutomationUser"
                       [legacyLoginUrl]="legacyLoginUrl"></ez-login-errors>
    }

    <div class="login-footer">
      <div id="forgotPasswordDiv">
        <a href="{{ forgotPasswordUrl }}">Forgot password?</a>
      </div>

      <div class="buttons">
        @if (overrideSessions) {
          <a href="login"
             id="btnCancel"
             color="primary"
             mat-stroked-button>Cancel</a>
        }
        <button mat-flat-button
                type="submit"
                color="primary"
                id="btnLogin"
                (click)="clearSsoLocalStorageVariables()">
          @if (overrideSessions) {
            Continue
          } @else {
            Log in
          }
        </button>
      </div>
    </div>
  </div>

  @if (lastSsoProvider) {
    <div class="sso-login">
      <mat-divider></mat-divider>
      <span>or</span>
      <a mat-flat-button
         color="accent"
         href="/auth/{{challengeUrl}}">Log in with {{ lastSsoProvider }} SSO</a>
    </div>
  }
} @else {
  <div class="login-form logged-in">
    <div>
      You are already logged in.
    </div>

    <div class="buttons logged-in">
      <a href="logout"
         id="btnLogout"
         mat-flat-button
         color="warn">Log out</a>

      <a href="{{ continueUrl }}"
         id="btnContinue"
         mat-flat-button
         color="primary">Continue to EZLynx</a>
    </div>
  </div>
}
